import { Link } from 'react-router-dom';
import { LoginForm } from './components/LoginForm';
import { AuthPageLayout } from './AuthPageLayout';
import { useAuth } from './context/AuthContext';

export default function LoginPage() {
  const { errorMessage, successMessage } = useAuth();

  return (
    <AuthPageLayout>
      {errorMessage && (
        <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
          <strong>Error:</strong> {errorMessage.description}
          {errorMessage.title === 'Email Not Verified' && (
            <div className="mt-2">
              <Link to="/verify-email" className="text-blue-600 hover:text-blue-500 underline">
                Click here to verify your email
              </Link>
            </div>
          )}
        </div>
      )}
      {successMessage && (
        <div className="mb-4 p-3 bg-green-100 border border-green-400 text-green-700 rounded">
          {successMessage}
        </div>
      )}
      <LoginForm />
      <br />
      <span className='text-sm font-medium text-gray-900 dark:text-gray-900'>
        Don't have an account yet?{' '}
        <Link to="/signup" className='underline'>
          go to signup
        </Link>
        .
      </span>
      <br />
      <span className='text-sm font-medium text-gray-900'>
        Forgot your password?{' '}
        <Link to="/reset-password" className='underline'>
          reset it
        </Link>
        .
      </span>
    </AuthPageLayout>
  );
}
